import classNames from 'classnames';
import { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

// Components.
import {
  AccessYourTraining,
  CertificationAccount,
  PearsonVueDashboard,
  Announcement,
  AddressVerification,
} from 'components';

// Hooks.
import { useProfile, useAnnouncements } from 'hooks';

// Styles.
import styles from './HomeView.module.scss';

export const HomeView = (): ReactElement => {
  const { t, i18n } = useTranslation();
  const [profile] = useProfile();
  const [announcements] = useAnnouncements(i18n.language);

  const renderAnnouncements = () => {
    return (
      <section
        id="announcements"
        className={classNames(styles.section, styles.sectionAnnouncements)}
      >
        <div className={styles.container}>
          {announcements?.map((announcement) => (
            <Announcement
              heading={announcement.heading}
              message={announcement.message}
              key={announcement.id}
            />
          ))}
        </div>
      </section>
    );
  };

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <div className={styles.welcomeHeader}>
        <div>
          <h1>
            {t('HomeView.WelcomeHeading')}
            {profile != null && (
              <span>
                ,&nbsp;
                <span>
                  {(profile.preferredName?.firstName ?? '').length > 0
                    ? profile.preferredName.firstName
                    : profile.givenName.firstName}
                </span>
              </span>
            )}
            !
          </h1>
        </div>
        <AddressVerification />
      </div>
      <div className={styles.columns}>
        <div className={styles.stacker}>
          {/* Section / Access Your Training */}
          <section
            id="accessYourTraining"
            className={classNames(
              styles.section,
              styles.sectionCards,
              styles.sectionLgPaddingBottom,
            )}
          >
            <AccessYourTraining />
          </section>
        </div>

        {/* QuickLinks */}
        <div className={styles.quickLinks}>
          <label>{t('HomeView.ExamsAndCertification')}</label>

          {/* Section / PearsonVueDashboard */}
          <section
            id="pearsonVueDashboard"
            className={classNames(styles.section, styles.sectionCards)}
          >
            <div className={styles.container}>
              <PearsonVueDashboard />
            </div>
          </section>

          <div className={styles.separator} />

          {/* Section Certification */}
          <section
            id="certificationAccount"
            className={classNames(styles.section, styles.sectionCards)}
          >
            <div className={styles.container}>
              <CertificationAccount />
            </div>
          </section>
        </div>
      </div>

      {announcements?.length > 0 ? renderAnnouncements() : <></>}
    </>
  );
};
